import script from "./TraningMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./TraningMenu.vue?vue&type=script&setup=true&lang=js"

import "./TraningMenu.vue?vue&type=style&index=0&id=2c570972&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c570972"]])

export default __exports__